export default [
  ['a', 'z', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
  ['q', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'k', 'l', 'l', 'm'],
  ['w', 'x', 'c', 'v', 'b', 'n'],
];



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/keyboard/layouts/FrenchLayout.jsx